import { Knob } from "@defibrillator/ui";

export function VolumeKnob({
  value,
  onChange,
}: {
  value: number;
  onChange: (v: number) => void;
}) {
  return (
    <Knob
      label="Volume"
      value={value}
      min={0}
      max={1}
      step={0.01}
      defaultValue={0.7}
      format={(v) => `${(v * 100).toFixed(0).padStart(3, "0")}%`}
      onChange={onChange}
    />
  );
}
